import { pick } from 'ramda'

import type { CreateCampaignApiArg, UpdateCampaignApiArg } from '@/__generated/es-api'
import type { CampaignSaveData } from '@/app/module/campaigns/types/save-data'

const writableCampaignFields = [
  'amd',
  'callAgainCustom',
  'callAgainMax',
  'callWindow',
  'contacts',
  'launch',
  'launchOpen',
  'name',
  'quotas',
  'reconnectMax',
  'reconnectOnProgress',
  'uiStore',
  'userStatuses',
  'variables',
] as const satisfies readonly (keyof UpdateCampaignApiArg['body'])[]

export const toCampaignUpdateBody = (
  item: CampaignSaveData<UpdateCampaignApiArg['body']>,
): UpdateCampaignApiArg['body'] => {
  const { quotas, userStatuses, ...fields } = pick(writableCampaignFields, item)

  // Null collections mean no change; empty arrays explicitly clear them.
  return {
    ...fields,
    ...(quotas != null
      ? {
          quotas: quotas.map(({ quotaId, conditions }) => ({
            quotaId,
            conditions: conditions?.length ? conditions : null,
          })),
        }
      : {}),
    ...(userStatuses != null ? { userStatuses } : {}),
  }
}

export const toCampaignCreateBody = (
  item: CampaignSaveData<CreateCampaignApiArg['body']>,
): CreateCampaignApiArg['body'] => ({
  ...toCampaignUpdateBody(item),
  ...(item.template !== undefined ? { template: item.template } : {}),
})
